<template>
	<v-card>
		<v-card-title>
			<h2>Szablony sprawozdań końcowych w naborach ({{departmentName}})</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>

		<v-dialog v-model="dialog" max-width="700px">
			<v-btn slot="activator" color="primary" dark class="mb-4">Dodaj szablon sprawozdania
			</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited"> Edycja szablonu sprawozdania</span>
					<span class="headline" v-else> Nowy szablon sprawozdania</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-text-field v-model="editedItem.name"
									browser-autocomplete="off"
									label="Nazwa szablonu"
									aria-label="template name"
									for="agency-contest-report-templates-list-name-template"
									id="agency-contest-report-templates-list-name-template"
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="saveTemplate"
						v-if="editedItem.name !== '' && editedItem.name !== undefined">{{ isEdited ? "Zapisz" :
							"Utwórz"}}
					</v-btn>
					<v-btn color="blue" @click="closeDialog">Anuluj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-alert :value="agencyContestReportTemplates.length === 0" type="info" class="ma-4">
			Brak szablonów.
		</v-alert>

		<v-list class="ma-3">
			<template v-for="template in agencyContestReportTemplates">
				<v-list-tile avatar :key="template.id">
					<v-list-tile-avatar>
						<v-icon large :color="getTemplateIconColor(template.status)">description</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title v-html="template.name"></v-list-tile-title>
						<v-list-tile-sub-title>{{getTemplateStatusMessage(template.status)}}</v-list-tile-sub-title>
					</v-list-tile-content>
					<v-list-tile-action>
						<egranty-icon-button
							icon="edit"
							color="blue"
							label="Zmień nazwę"
							for="agency-contest-report-templates-list-change-name"
							id="agency-contest-report-templates-list-change-name"
							@click="editTemplate(template)"/>
					</v-list-tile-action>
					<v-list-tile-action>
						<egranty-icon-button
							icon="view_list"
							color="blue darken-4"
							label="Edytuj szablon"
							for="agency-contest-report-templates-list-edit-template"
							id="agency-contest-report-templates-list-edit-template"
							@click="editSchema(template.id)"/>
					</v-list-tile-action>
					<v-list-tile-action>
						<egranty-icon-button
							icon="delete"
							color="lightred"
							label="Usuń szablon"
							for="agency-contest-report-templates-list-delete-template"
							id="agency-contest-report-templates-list-delete-template"
							@click="removeTemplate(template)"/>
					</v-list-tile-action>
				</v-list-tile>
			</template>
		</v-list>
	</v-card>
</template>

<script>
	import {Department} from "../../../api/generated/Department";
	import {AgencyContestReportTemplate} from "../../../api/generated/AgencyContestReportTemplate";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";

	export default {
		name: "AgencyagencyContestReportTemplatesList",
		components: {EgrantyIconButton},
		data () {
			return {
				dialog: false,
				departmentName: "",
				agencyContestReportTemplates: [],
				editedItem: {},
				editedIndex: -1
			};
		},

		created () {
			this.refresh();
		},

		methods: {

			refresh () {
				getDepartmentName(this);
				getTemplates(this);
			},

			closeDialog () {
				this.dialog = false;
				this.editedIndex = -1;
				this.editedItem = {};
			},

			getTemplateStatusMessage (status) {
				switch (status) {
					case 'NEW':
						return "Niezdefiniowany";
					case 'DEFINED':
						return "Zdefiniowany";
					case 'ASSIGNED':
						return "Przypisany do naboru ############";
				}
			},

			getTemplateIconColor (status) {
				switch (status) {
					case 'NEW':
						return "grey";
					case 'DEFINED':
						return "amber";
					case 'ASSIGNED':
						return "blue";
				}
			},

			editTemplate (item) {
				this.editedIndex = this.agencyContestReportTemplates.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			saveTemplate () {
				if (this.editedIndex === -1) {
					createTemplate(this);
				} else {
					updateTemplate(this);
				}
			},

			editSchema (templateId) {
				this.$router.push("/app/agency-contest-report-templates/" + this.$route.params.departmentId + "/form/" + templateId);
			},

			removeTemplate (item) {
				this.$confirm("Czy na pewno chcesz usunąć szablon?", {
					icon: 'delete',
					title: 'Uwaga',
					color: "lightred",
					width: 500
				})
					.then(response => {
						if (response) deleteTemplate(this, item.id, this.agencyContestReportTemplates.indexOf(item));
					});
			},
		},

		watch: {
			"$route.params": function () {
				this.refresh();
			}
		},

		computed: {
			isEdited () {
				return this.editedIndex !== -1;
			}
		},
	};

	function getDepartmentName (ctx) {
		Department.getName(ctx, ctx.$route.params.departmentId, successResponse => {
				ctx.departmentName = successResponse.name;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować nazwy departamentu", errorResponse);
			});
	}

	function getTemplates (ctx) {
		AgencyContestReportTemplate.getList(ctx, ctx.$route.params.departmentId, successResponse => {
				ctx.agencyContestReportTemplates = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować szablony sprawozdania", errorResponse);
			});
	}

	function createTemplate (ctx) {
		AgencyContestReportTemplate.post(ctx, ctx.$route.params.departmentId, ctx.editedItem.name, successResponse => {
				ctx.editedItem.id = successResponse;
				ctx.editedItem.status = 'NEW';
				ctx.agencyContestReportTemplates.push(ctx.editedItem);
				ctx.closeDialog();
				ctx.$messagesBus.$emit("success", "Szablon sprawozdania został pomyślnie dodany", successResponse);
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
			});
	}

	function updateTemplate (ctx) {
		AgencyContestReportTemplate.put(ctx, ctx.editedItem.id, ctx.editedItem.name, successResponse => {
				ctx.agencyContestReportTemplates[ctx.editedIndex].name = ctx.editedItem.name;
				ctx.closeDialog();
				ctx.$messagesBus.$emit("success", "Nazwa szablonu sprawozdania została pomyślnie zmieniona", successResponse);
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
			});
	}

	function deleteTemplate (ctx, templateId, index) {
		AgencyContestReportTemplate.delete(ctx, templateId, successResponse => {
				ctx.agencyContestReportTemplates.splice(index, 1);
				ctx.$messagesBus.$emit("success", "Szablon został pomyślnie usunięty", successResponse);
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
			});
	}
</script>

<style scoped>

</style>
